import Carousal from './carousal.comp'

export { Carousal }
